exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tag-container[data-v-5c0c0914]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px}.tag-item[data-v-5c0c0914]{margin:0;border-radius:16px}.no-tags-text[data-v-5c0c0914]{color:#909399;font-size:14px}", "", {"version":3,"sources":["/workspace/src/views/users/pages/UsersForm.vue"],"names":[],"mappings":"AACA,gCAAgC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,OAAO,CAC7H,AACD,2BAA2B,SAAS,kBAAkB,CACrD,AACD,+BAA+B,cAAc,cAAc,CAC1D","file":"UsersForm.vue","sourcesContent":["\n.tag-container[data-v-5c0c0914]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px\n}\n.tag-item[data-v-5c0c0914]{margin:0;border-radius:16px\n}\n.no-tags-text[data-v-5c0c0914]{color:#909399;font-size:14px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c0c0914","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/users/pages/UsersForm.vue
// module id = 5805
// module chunks = 51